import { RouteComponentProps } from "react-router";
import "./RouteText.css";

const RouteText = ({
  routes,
  currentLocation,
  routeProps,
}: {
  routes: { name: string; route: string }[];
  currentLocation: string;
  routeProps: RouteComponentProps;
}) => {
  return (
    <h3 id="routeTextContainer">
      {routes.map((item, index) => (
        <span key={index}>
          <span className="route" onClick={() => routeProps.history.push(item.route)}>
            {item.name}
          </span>{" "}
          /{" "}
        </span>
      ))}{" "}
      {currentLocation}
    </h3>
  );
};

export default RouteText;
